/**
 * Customers Table Component
 * 
 * This component displays a table of customers with
 * their basic information and order statistics.
 */

import React from 'react';
import { useApp } from '../../context/AppContext';
import { useTranslations } from '../../context/TranslationsContext';

const CustomersTable = ({ customers, onViewDetails }) => {
  const { translations } = useTranslations();
  const { state } = useApp();
  const t = translations[state.currentLanguage];

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString(state.currentLanguage === 'ar' ? 'ar-SA' : 'en-US');
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat(state.currentLanguage === 'ar' ? 'ar-SA' : 'en-US').format(price);
  };

  return (
    <div className="table-container">
      <table className="data-table">
        <thead>
          <tr>
            <th>{t.customerName}</th>
            <th>{t.phone}</th>
            <th>{t.address}</th>
            <th>{t.totalOrders}</th>
            <th>{t.totalAmounts}</th>
            <th>{t.createdAt}</th>
            <th>{t.actions}</th>
          </tr>
        </thead>
        <tbody>
          {customers.map(customer => (
            <tr key={customer.phone_number}>
              <td>{customer.name}</td>
              <td>{customer.phone_number}</td>
              <td>{customer.address}</td>
              <td>{customer.total_orders || 0}</td>
              <td>{formatPrice(customer.total_spent || 0)} {t.sar}</td>
              <td>{formatDate(customer.created_at)}</td>
              <td>
                <button
                  onClick={() => onViewDetails(customer)}
                  className="btn-secondary btn-sm"
                >
                  {t.viewDetails}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CustomersTable;
